import * as am5 from '@amcharts/amcharts5';

export const THREAT_COLORS: Record<string, am5.Color> = {
    "ips_seen_as_c2": am5.color(0xfb842a), // orange
    "ips_seen_as_bot": am5.color(0xd62c15), // red
    "ips_seen_as_phish": am5.color(0xd6c015), // yellow
    "ips_seen_as_malware": am5.color(0x0d9ed9), // blue
    "ips_seen_as_scan": am5.color(0x54e4a5), // mint green
    "ips_seen_as_spam": am5.color(0x4646da), // indigo
    "ips_seen_as_popular": am5.color(0xFF9F40), // amber
    "ips_seen_as_proxy": am5.color(0x8e44ad), // purple
    "ips_seen_as_ransomware_payments": am5.color(0x2ecc71), // emerald green
    "ips_seen_as_newly_registered_domain": am5.color(0x1abc9c), // teal
    "ips_seen_as_reflector": am5.color(0xf39c12), // golden orange
    "ips_seen_as_attack": am5.color(0xe74c3c), // crimson
    "ips_seen_as_victim": am5.color(0x3498db), // sky blue

    // Friendly used in timeline / heatmap (from top-metrics)
    "C2": am5.color(0xfb842a),
    "Bot": am5.color(0xd62c15),
    "Phish": am5.color(0xd6c015),
    "Malware": am5.color(0x0d9ed9),
    "Scan": am5.color(0x54e4a5),
    "Spam": am5.color(0x4646da),
    "Popular": am5.color(0xFF9F40),
    "Proxy": am5.color(0x8e44ad),
    "Ransomware Payments": am5.color(0x2ecc71),
    "Newly Registered Domain": am5.color(0x1abc9c),
    "Reflector": am5.color(0xf39c12),
    "Attack": am5.color(0xe74c3c),
    "Victim": am5.color(0x3498db),
    "Suspicious": am5.color(0xf4d03f),
    "Unknown": am5.color(0x888888),

    // NAICS sector colors
    "11": am5.color(0xfb842a), // orange Agriculture_Forestry_Fishing_and_Hunting
    "21": am5.color(0x54e4a5), // mint green Mining_Quarrying_and_Oil_and_Gas_Extraction
    "22": am5.color(0xd6c015), // yellow Utilities
    "23": am5.color(0x0d9ed9), // blue Construction
    "31": am5.color(0xd62c15), // red Manufacturing
    "32": am5.color(0xd62c15), // red Manufacturing
    "33": am5.color(0xd62c15), // red Manufacturing
    "42": am5.color(0x4646da), // indigo Wholesale_Trade
    "44": am5.color(0xFF9F40), // amber Retail_Trade
    "45": am5.color(0xFF9F40), // amber Retail_Trade
    "48": am5.color(0x8e44ad), // purple Transportation_and_Warehousing
    "49": am5.color(0x8e44ad), // purple Transportation_and_Warehousing
    "51": am5.color(0x2ecc71), // emerald green Information
    "52": am5.color(0x1abc9c), // teal Finance_and_Insurance
    "53": am5.color(0xf39c12), // golden orange Real_Estate_and_Rental_and_Leasing
    "54": am5.color(0xe74c3c), // crimson Professional_Scientific_and_Technical_Services
    "55": am5.color(0x3498db), // sky blue Management_of_Companies_and_Enterprises
    "56": am5.color(0xf4bdbd), // light pink Administrative_and_Support_and_Waste_Management_and_Remediation_Services
    "61": am5.color(0x095b99), // dark blue Educational_Services
    "62": am5.color(0xffe599), // light yellow Health_Care_and_Social_Assistance
    "71": am5.color(0xe06666), // pastel red Arts_Entertainment_and_Recreation
    "72": am5.color(0xb4a7d6), // lavender Accommodation_and_Food_Services
    "81": am5.color(0x744700), // doo doo brown Other_Services
    "92": am5.color(0xd90d85), // magenta Public_Administration
};

// Equal to NAICS colours - for top sector/industry visual
export const NAICS_COLORS: Record<string, string> = {
    '11': '#fb842a', '21': '#54e4a5', '22': '#d6c015', '23': '#0d9ed9',
    '31': '#d62c15', '32': '#d62c15', '33': '#d62c15',
    '42': '#4646da', '44': '#FF9F40', '45': '#FF9F40',
    '48': '#8e44ad', '49': '#8e44ad',
    '51': '#2ecc71', '52': '#1abc9c', '53': '#f39c12', '54': '#e74c3c',
    '55': '#3498db', '56': '#f4bdbd', '61': '#095b99', '62': '#ffe599',
    '71': '#e06666', '72': '#b4a7d6', '81': '#744700', '92': '#d90d85'
};
